module.exports = __webpack_public_path__ + "static/img/アセット 73@3x.5d02123.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 73@3x.png
// module id = QJf1
// module chunks = 1